module.exports = __webpack_public_path__ + "img/IMG_6730.39a6e25a.jpeg";